import React, { useEffect } from 'react';
import { initFbPixel, trackPageView } from './utils/fbPixel';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    initFbPixel();
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}